/**
 * DynamicRequestEditFields
 *
 * Generic, declarative inline-EDIT fields for a request type defined by a `fields`
 * array — the inline-edit mirror of DynamicRequestFields, laid out in the shared
 * `.task-rtd-edit-grid` (label-above-control). Reuses the same `renderInput` so the
 * controls match the create form. Custom types (e.g. IO) supply their own `EditFields`.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { renderInput, fieldRules } from './DynamicRequestFields';

const isFullWidth = (field) => field.type === 'url' || field.type === 'textarea';

const DynamicRequestEditFields = ({ fields }) => (
  <div className="task-rtd-edit-grid">
    {(fields || []).map((field) => (
      <div
        key={field.name}
        className={`task-rtd-edit-grid__field${isFullWidth(field) ? ' task-rtd-edit-grid__field--full' : ''}`}
      >
        <span className="task-rtd-edit-grid__label">{field.label}</span>
        <Form.Item
          name={field.name}
          noStyle
          rules={fieldRules(field)}
          valuePropName={field.type === 'switch' ? 'checked' : undefined}
        >
          {renderInput(field)}
        </Form.Item>
      </div>
    ))}
  </div>
);

DynamicRequestEditFields.propTypes = {
  fields: PropTypes.array,
};

DynamicRequestEditFields.defaultProps = {
  fields: [],
};

export default DynamicRequestEditFields;
